<template>
  <WorkFormDialog
    ref="workFormDialog"
    :promise-based-api-request-handler-method="handleApiRequest"
    width="sm"
    :value="data"
    persistent
    no-simple-close
  >
    <template #header>
      {{ $t('Login.sentences.changeTemporaryPasswordTitle') }}
    </template>
    <template #content>
      <w-row>
        <w-column>
          {{ $t('Login.sentences.plzChangeTemporaryPassword') }}
        </w-column>
      </w-row>
      <w-row>
        <w-column>
          <w-form-password-field
            v-model='password'
            :label="$t('UserView.fields.password')"
            :rules="passwordRules"
            vid='pw'
          />
        </w-column>
      </w-row>
      <w-row>
        <w-column>
          <w-form-password-field
            v-model='passwordRepeat'
            :label="$t('UserView.fields.password-repeat')"
            name='pwconfirm'
            :rules='password != undefined ? "confirmed:@pw" : ""'
          />
        </w-column>
      </w-row>
      <w-row v-if="passwordPatternDescription">
        <w-column>
          <div
            class="password-pattern-description"
            v-html="passwordPatternDescription"
          />
        </w-column>
      </w-row>
    </template>
    <template #dialog-actions="{ triggerResolve, submitPending }">
      <w-btn
        @click="logout()"
      >
        {{ $t('Common.cancel') }}
      </w-btn>
      <w-btn
        :disabled="!canBeSaved"
        :loading="submitPending"
        @click="triggerResolve"
      >
        {{ $t('Common.save') }}
      </w-btn>
    </template>
  </WorkFormDialog>
</template>

<script>
import axios from 'axios';
import actingUserService from '@/services/acting-user-service';
import WorkFormDialog from '@/components/base_components/dialog/form_dialogs/WorkFormDialog';
import registryMixin from "@/mixins/registry-mixin";
import staticData from "@/mixins/api_data/static-data-mixin";
import WorkAuthentication from '@/services/authentication_services/WorkAuthentication';
import { mapActions, mapState, mapGetters } from "vuex"

const ROUTE = '/rest/v4/profile';

export default {
  name: "ForceTemporaryPasswordChangeDialog",
  components: {
    WorkFormDialog,
  },
  mixins: [
    staticData('registries', 'configurations/profile', (registries) => registries?.registryDtos, undefined),
    registryMixin(
      'passwordPatternDescription',
      'Work.Password.Pattern.Description',
      'configurations/profile'
    ),
    registryMixin(
      'passwordPatternRegex',
      'Work.Password.Pattern.RegEx',
      'configurations/profile'
    ),
  ],
  data() {
    return {
      data: { data: {} },
      password: undefined,
      passwordRepeat: undefined,
    };
  },
  computed: {
    ...mapState('actingUser', ['actingUserDetails']),
    ...mapGetters('registries', ['getRegistry']),
    canBeSaved() {
      return this.password != undefined && this.passwordRepeat != undefined
    },
    passwordRules() {
      if (this.password != undefined)
          return {required: true, passwordRegex: this.passwordPatternRegex ? this.passwordPatternRegex : ''};
      return '';
    }
  },
  methods: {
    ...mapActions('registries', ['loadRegistries']),
    logout() {
      WorkAuthentication.logout();
    },
    async open() {
      if(!this.getRegistry('configurations/profile')) 
        await this.loadRegistries('configurations/profile');

      return axios.get(ROUTE).then((response) => {
        this.data = response.data.data;
        this.$refs.workFormDialog.open();
      });
    },
    handleApiRequest(data) {
      data.data['newPassword'] = this.password;
      data.data['newPasswordValidation'] = this.passwordRepeat;

      return axios.put(ROUTE, data).then(()=> {
        actingUserService.refreshActingUserInfo();
        return this.$refs.workFormDialog.close();
      });
    }
  },
};
</script>

<style lang="css" scoped>
.password-pattern-description {
  white-space: pre-wrap;
}
</style>
